import React, { useState } from 'react';
import './WardCart.css';

const WardCart = ({ isOpen, closeSidebar }) => {
  const [openCardIndex, setOpenCardIndex] = useState(null);
  const [selectedMedicine, setSelectedMedicine] = useState(null); 
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editedMedicine, setEditedMedicine] = useState({}); 
  const handleViewMeds = (index) => {
    setOpenCardIndex(openCardIndex === index ? null : index);
  };

  const handleEditClick = (med) => {
    setSelectedMedicine(med); 
    setEditedMedicine({ ...med }); 
    setIsModalOpen(true); 
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setEditedMedicine({}); 
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedMedicine((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSaveChanges = () => {
    setSelectedMedicine(editedMedicine);
    setIsModalOpen(false);
  };

  const medicineData = [
    {
      department: "Cardiology",
      issueDate: "2024-12-04",
      batchId: "BATCH123",
      medName: "Aspirin",
      quantityGiven: "100",
      ratePerUnit: "5",
      quantityAsked: "50",
    },
    {
      department: "Cardiology",
      issueDate: "2024-12-05",
      batchId: "BATCH125",
      medName: "Lisinopril",
      quantityGiven: "150",
      ratePerUnit: "12",
      quantityAsked: "100",
    },
    {
      department: "Cardiology",
      issueDate: "2024-12-06",
      batchId: "BATCH126",
      medName: "Metoprolol",
      quantityGiven: "200",
      ratePerUnit: "8",
      quantityAsked: "180",
    },
    {
      department: "Neurology",
      issueDate: "2024-12-02",
      batchId: "BATCH124",
      medName: "Ibuprofen",
      quantityGiven: "200",
      ratePerUnit: "3",
      quantityAsked: "150",
    },
    {
      department: "Neurology",
      issueDate: "2024-12-03",
      batchId: "BATCH127",
      medName: "Gabapentin",
      quantityGiven: "250",
      ratePerUnit: "6",
      quantityAsked: "200",
    },
    {
      department: "Neurology",
      issueDate: "2024-12-04",
      batchId: "BATCH128",
      medName: "Carbamazepine",
      quantityGiven: "100",
      ratePerUnit: "10",
      quantityAsked: "80",
    },
  ];

  const groupedMedicines = medicineData.reduce((acc, med) => {
    if (!acc[med.department]) {
      acc[med.department] = [];
    }
    acc[med.department].push(med);
    return acc;
  }, {});

  return (
    <div className={`departments-cart-sidebar ${isOpen ? 'open' : ''}`}>
      <div className="departments-cart-sidebar-header">
        <h2 className="header">Department's Cart</h2>
        <button className="close-cart-btn" onClick={closeSidebar}>
          &times;
        </button>
      </div>
      <div className="departments-cart-items">
        {Object.keys(groupedMedicines).map((department, index) => (
          <div className="department-card" key={index}>
            <div className="department-card-header">
              <div className="department-name">{department} Ward</div>
              <div className="issue-date">
                {groupedMedicines[department][0].issueDate} 
              </div>
            </div>
            <div className="view-meds-btn-container">
              <button className="view-meds-btn" onClick={() => handleViewMeds(index)}>
                View Meds
                <span className={`arrow-icon ${openCardIndex === index ? 'open' : ''}`}>↓</span>
              </button>
            </div>
            {openCardIndex === index && (
              <div className="medicine-table-department-sidebar">
                <table className="med-table-department-sidebar">
                  <thead>
                    <tr>
                      <th>Batch ID</th>
                      <th>Medicine Name</th>
                      <th>Quantity Given</th>
                      <th>Rate per Unit</th>
                      <th>Quantity Asked</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {groupedMedicines[department].map((med, idx) => (
                      <tr key={idx}>
                        <td>{med.batchId}</td>
                        <td>{med.medName}</td>
                        <td>{med.quantityGiven}</td>
                        <td>{med.ratePerUnit} ₹</td>
                        <td>{med.quantityAsked}</td>
                        <td>
                          <button className="edit-btn" onClick={() => handleEditClick(med)}>
                            Edit
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <div className="send-notification-btn-container">
              <button className="send-notification-btn-ward-cart">
                Send Pickup Notification
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className="departments-cart-sidebar-footer">
        <button className="checkout-btn">Send Pickup Notifications to All</button>
      </div>

      
{isModalOpen && selectedMedicine && (
  <div className="modal-depart-cart" id="Depart-modal-cart">
    <div className="modal-content-depart-cart">
      
      <h3>Edit Medicine</h3>
      <label>
        Medicine Name:
        <input
          type="text"
          name="medName"
          value={editedMedicine.medName}
          onChange={handleInputChange}
        />
      </label>
      <label>
        Quantity Given:
        <input
          type="number"
          name="quantityGiven"
          value={editedMedicine.quantityGiven}
          onChange={handleInputChange}
        />
      </label>
      <label>
        Rate per Unit:
        <input
          type="number"
          name="ratePerUnit"
          value={editedMedicine.ratePerUnit}
          onChange={handleInputChange}
        />
      </label>
      <label>
        Quantity Asked:
        <input
          type="number"
          name="quantityAsked"
          value={editedMedicine.quantityAsked}
          onChange={handleInputChange}
        />
      </label>
      <button className="save-btn-depart-cart" onClick={handleSaveChanges}>
        Save Changes
      </button>
      <button className="cancel-btn-depart-cart" onClick={handleModalClose}>
        Cancel
      </button>
    </div>
  </div>
)}

    </div>
  );
};

export default WardCart;
